"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cluster = void 0;
var _react = _interopRequireDefault(require("react"));
var _api = require("@react-google-maps/api");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ramda = require("ramda");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getPixelPositionOffset = function getPixelPositionOffset(width, height) {
  return {
    x: -(width / 2),
    y: -(height / 2)
  };
};
var getClassNameByCount = (0, _ramda.cond)([[function (count) {
  return count <= 9;
}, (0, _ramda.always)(_styles.default.green)], [function (count) {
  return count <= 99;
}, (0, _ramda.always)(_styles.default.yellow)], [_ramda.T, (0, _ramda.always)(_styles.default.red)]]);
var Cluster = exports.Cluster = function Cluster(_ref) {
  var count = _ref.count,
    position = _ref.position;
  return /*#__PURE__*/_react.default.createElement(_api.OverlayView, {
    position: position,
    mapPaneName: _api.OverlayView.OVERLAY_MOUSE_TARGET,
    getPixelPositionOffset: getPixelPositionOffset
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.marker, getClassNameByCount(count))
  }, count));
};
Cluster.propTypes = {
  count: _propTypes.default.number.isRequired,
  position: _propTypes.default.exact({
    lat: _propTypes.default.number.isRequired,
    lng: _propTypes.default.number.isRequired
  }).isRequired
};